let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ao95w")).then(() => parcelRequire('7PzL9'));